<p-fieldset legend="Lotes/Itens">
  <div class="row">
    <div class="col-12">
      <button (click)="adicionar()" class="btn btn-sm btn-outline-primary" [disabled]="itemAtual">
        <i class="fa fa-plus"></i> Adicionar
      </button>
    </div>
  </div>
  <table class="table table-eddy table-sm">
    <thead>
      <tr>
        <th scope="col">Lote/Habilitação</th>
        <th scope="col">Proposta R$/%</th>
        <th scope="col">Compatível/Fonte</th>
        <th scope="col">Motivo</th>
        <th scope="col"></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of licitante?.LicitanteLoteItens">
        <td>
          <span *ngIf="!item.editavel" class="d-block">{{funcaoService.obterNomePorChave(lotes,
            item.LicitanteNumLote)}}</span>
          <span *ngIf="!item.editavel" class="d-block">{{funcaoService.obterNomePorChave(opcoesHabilitacao,
            item.ResultadoHabilitacao)}}</span>
          <select *ngIf="item.editavel" [compareWith]="compareFn" class="form-control d-block"
            [(ngModel)]="itemAtual.LicitanteNumLote" [ngModelOptions]="{standalone: true}">
            <option *ngFor="let item of lotes" [ngValue]="item.id">{{item.nome}}</option>
          </select>
          <select *ngIf="item.editavel" [compareWith]="compareFn" class="form-control d-block"
            [(ngModel)]="itemAtual.ResultadoHabilitacao" [ngModelOptions]="{standalone: true}">
            <option *ngFor="let item of opcoesHabilitacao" [ngValue]="item.id">{{item.nome}}</option>
          </select>
        </td>

        <td>
          <span *ngIf="!item.editavel" class="d-block">{{item.ValorProposta}}</span>
          <span *ngIf="!item.editavel" class="d-block">{{item.ValorPropostaPercentual}}</span>
          <input *ngIf="item.editavel" type="text" class="form-control d-block" [(ngModel)]="itemAtual.ValorProposta"
            [ngModelOptions]="{standalone: true}" unmask="typed" [imask]="imaskConfig">
          <input *ngIf="item.editavel" type="text" class="form-control d-block"
            [(ngModel)]="itemAtual.ValorPropostaPercentual" [ngModelOptions]="{standalone: true}" unmask="typed"
            [imask]="imaskConfig">
        </td>

        <td>
          <span *ngIf="!item.editavel" class="d-block">{{item.CompativelMercadoValor}}</span>
          <span *ngIf="!item.editavel" class="d-block">{{item.CompativelMercadoFonte}}</span>
          <p-selectButton *ngIf="item.editavel && itemAtual.ResultadoHabilitacao === 2" [options]="opcoesSimNao"
            optionValue="id" class="d-block" [(ngModel)]="itemAtual.CompativelMercadoValor"
            [ngModelOptions]="{standalone: true}">
            <ng-template let-opcao>
              <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
            </ng-template>
          </p-selectButton>
          <input *ngIf="item.editavel && itemAtual.ResultadoHabilitacao === 2" type="text" class="form-control d-block"
            [(ngModel)]="itemAtual.CompativelMercadoFonte" [ngModelOptions]="{standalone: true}">
        </td>

        <td>
          <span *ngIf="!item.editavel">{{item.MotivoDesab_Desclass}}</span>
          <textarea
            *ngIf="item.editavel && (itemAtual.ResultadoHabilitacao === 1 || itemAtual.ResultadoHabilitacao === 3 || itemAtual.ResultadoHabilitacao === 8)"
            class="form-control" rows="3" [(ngModel)]="itemAtual.MotivoDesab_Desclass"
            [ngModelOptions]="{standalone: true}"></textarea>
        </td>

        <td class="text-right">
          <button *ngIf="!item.editavel" (click)="visualizar(item)" class="btn btn-sm btn-outline-primary mr-2">
            <img src="assets/img/global/pencil.png" alt="editar" height="16" width="16">
          </button>
          <button *ngIf="!item.editavel" (click)="remover(item)" class="btn btn-sm btn-outline-primary mr-2">
            <img src="assets/img/global/bin_closed.png" alt="remover" height="16" width="16">
          </button>
          <button *ngIf="item.editavel" (click)="salvar()" class="btn btn-sm btn-outline-primary mr-2">
            <img src="assets/img/global/tick.png" alt="salvar" height="16" width="16">
          </button>
          <button *ngIf="item.editavel" (click)="cancelar()" class="btn btn-sm btn-outline-primary mr-2">
            <img src="assets/img/global/cross.png" alt="cancelar" height="16" width="16">
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</p-fieldset>